import { extractUrlFromLinkJsonLd } from '../url';
export var extractImage = function extractImage(jsonLd) {
  var image = jsonLd.image;
  if (image) {
    if (typeof image === 'string') {
      return image;
    } else if (image['@type'] === 'Link') {
      return extractUrlFromLinkJsonLd(image);
    } else if (image['@type'] === 'Image') {
      if (image.url) {
        return extractUrlFromLinkJsonLd(image.url);
      }
    }
  }
};